export enum CourtEventModalsActionTypes {
    CancelCourtBooking = '[CourtEventModals] Cancel court booking',
    CancelCourtBookingSuccess = '[CourtEventModals] Cancel court booking success',
    CancelBlockedSlot = '[CourtEventModals] Cancel blocked slot',
    CancelBlockedSlotSuccess = '[CourtEventModals] Cancel blocked slot success'
}

export class CancelCourtBookingAction {
    static type = CourtEventModalsActionTypes.CancelCourtBooking;
    constructor(public courtBookingId: string) {}
}

export class CancelCourtBookingSuccessAction {
    static type = CourtEventModalsActionTypes.CancelCourtBookingSuccess;
}

export class CancelBlockedSlotAction {
    static type = CourtEventModalsActionTypes.CancelBlockedSlot;
    constructor(public blockedSlotId: string) {}
}

export class CancelBlockedSlotSuccessAction {
    static type = CourtEventModalsActionTypes.CancelBlockedSlotSuccess;
}
